import { Theme } from "@mui/material";

export const getStyles = (theme: Theme) => ({
  alert: {
    width: "100%",
    alignItems: "center",
    py: 0.5,
    px: 1,
    flexWrap: "nowrap",
    "& .MuiAlert-icon": {
      py: 0.5,
      px: 0,
      mr: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    "& .MuiAlert-message": {
      py: 0.5,
      px: 0,
      whiteSpace: "wrap",
    },
    "& .MuiAlert-action": {
      paddingTop: 0,
      paddingBottom: 0,
      ml: "auto",
      mr: 0,
      alignItems: "center",
      whiteSpace: "nowrap",
    },
  },
  actionText: { display: "flex", minWidth: 0 },
  truncatedRightText: {
    fontWeight: theme.typography.fontWeightRegular as number,
    fontSize: theme.fontSizes.md,
    textAlign: "right",
    maxWidth: {
      xs: 80, // 80px
      sm: 120, // 120px
      md: 200, // 200px
    },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
